module.exports = __webpack_public_path__ + "static/media/chat1.05d457c3.svg";